export default {
  meta: {
    title: 'POI地图门店品牌配置',
  },
};
